import React, {useState} from 'react';
import { useLocation } from 'react-router-dom';

// helpers
import gameStates from '../helpers/gameState';

export const RootContext = React.createContext([{}, p => {}]);

export default ({ children }) => {

  const { REACT_APP_LANGUAGE } = process.env;
  const location = useLocation();
  const isRussian = location.search && location.search.toLowerCase().includes('lang=ru');
  const language = (isRussian && (REACT_APP_LANGUAGE === 'et' || REACT_APP_LANGUAGE === 'lv')) ? 'ru' : REACT_APP_LANGUAGE;

  const [state, setState] = useState({
    gameState: gameStates.INTRO,
    // OVERRIDE
    // gameState: gameStates.QUESTION_10,
    // gameState: gameStates.ENDED,
    
    language,
    hasChanged: false,
    totalScore: 0,
    otherPlayers: 0,
    isPlayingBackgroundMusic: false,
    isListeningToAudio: false,
    randomNumber: Math.floor(Math.random() * (12 - 1 + 1) + 1),
    trackUser: false,
    gtmInitialized: false
  });

  return (
    <RootContext.Provider value={[state, setState]}>
      {children}
    </RootContext.Provider>
  );
};
